const config = require('@config.json');
const commonConfig = require('@common-config.json');
const transformer = require('./assets/configJsonTransformer');

module.exports = {
    ...transformer(commonConfig, config)
};
